class C_CockpitParts
{
    constructor()
    {
        this.partsLandscape =
        {
            1: [
                {
                    id: 1,
                    isWeapon: true,
                    weaponId: 0,
                    name: "cockpit1_cannon_left",
                    shootFrame: "cockpit1_cannon_left_shoot"
                },
                {
                    id: 2,
                    isWeapon: true,
                    weaponId: 1,
                    name: "cockpit1_cannon_right",
                    shootFrame: "cockpit1_cannon_right_shoot"
                },
                {
                    id: 3,
                    name: "cockpit1_left_1",
                },
                {
                    id: 4,
                    name: "cockpit1_left_2",
                },
                {
                    id: 5,
                    name: "cockpit1_left_3",
                },
                {
                    id: 6,
                    name: "cockpit1_right_1",
                },
                {
                    id: 7,
                    name: "cockpit1_right_2",
                },
                {
                    id: 8,
                    name: "cockpit1_right_3",
                },
                {
                    id: 9,
                    name: "cockpit1_left_glow_1",
                    duration: 1,
                    delay: 0,
                    glow: true
                },
                {
                    id: 10,
                    name: "cockpit1_left_glow_2",
                    duration: 1,
                    delay: 0.2,
                    glow: true
                },
                {
                    id: 11,
                    name: "cockpit1_neon_left_",
                    tweenType : "timeline",
                    parts:4,
                    glow: true
                },
                {
                    id: 12,
                    name: "cockpit1_right_glow_1",
                    duration: 1,
                    delay: 0.8,
                    glow: true
                },
                {
                    id: 13,
                    name: "cockpit1_right_glow_2",
                    duration: 1,
                    delay: 0.6,
                    glow: true
                },
                {
                    id: 14,
                    name: "cockpit1_neon_right_",
                    tweenType : "timeline",
                    parts:4,
                    glow: true
                },
                {
                    id: 15,
                    name: "cockpit1_middle_crystal",
                },
                {
                    id: 16,
                    name: "cockpit1_middle_crystal_glow",
                    duration: 2,
                    glow: true
                },
                {
                    id: 17,
                    name: "cockpit1_right_crystal",
                },
                {
                    id: 18,
                    name: "cockpit1_right_crystal_glow",
                    duration: 3,
                    glow: true
                },
                {
                    id: 19,
                    name: "fireball_",
                    animation: true,
                    frames: 6,
                    lastFrame: 5,
                    animSpeed: 0.3
                },
                {
                    id: 20,
                    name: "cockpit1_ball_armor",
                },
                {
                    id: 21,
                    name: "cockpit1_ball_glow",
                    duration: 1,
                    delay: 0.4,
                    glow: true
                },
            ],
            2:
                [
                    {
                        id: 1,
                        isWeapon: true,
                        weaponId: 0,
                        name: "cockpit2_cannon_left",
                        shootFrame: "cockpit2_cannon_left_shoot"
                    },
                    {
                        id: 2,
                        isWeapon: true,
                        weaponId: 1,
                        name: "cockpit2_cannon_right",
                        shootFrame: "cockpit2_cannon_right_shoot"
                    },
                    {
                        id: 3,
                        name: "cockpit2_1",
                    },
                    {
                        id: 4,
                        name: "cockpit2_2",
                    },
                    {
                        id: 5,
                        name: "cockpit2_3",
                    },
                    {
                        id: 6,
                        name: "cockpit2_4",
                    },
                    {
                        id: 7,
                        name: "cockpit2_5",
                    },
                    {
                        id: 8,
                        name: "cockpit2_6",
                    },
                    {
                        id: 9,
                        name: "cockpit2_7",
                    },
                    {
                        id: 10,
                        name: "cockpit2_red_light_left_",
                        tweenType : "loading",
                        delay: 0.2,
                        parts: 4,
                        glow: true
                    },
                    {
                        id: 11,
                        name: "cockpit2_red_light_right_",
                        tweenType : "loading",
                        delay: 0.2,
                        parts: 4,
                        glow: true
                    },
                    {
                        id: 12,
                        name: "cockpit2_paw",
                        duration: 1.5,
                        repeatDelay: 0,
                        glow: true
                    },
                    {
                        id: 13,
                        name: "cockpit2_screen_left",
                    },
                    {
                        id: 14,
                        name: "cockpit2_screen_right",
                    },
                    {
                        id: 15,
                        name: "cockpit2_deco_1",
                        anchor: new PIXI.Point(0.429, 0),
                        position: new PIXI.Point(0.925, 0.307),
                        rotation: Math.PI/10,
                        duration: 1
                    },
                    {
                        id: 16,
                        name: "cockpit2_deco_2",
                        anchor: new PIXI.Point(0.5, 0),
                        position:new PIXI.Point(0.955, 0.279),
                        rotation: Math.PI/9,
                        duration: 0.9
                    },
                    {
                        id: 17,
                        name: "cockpit2_deco_3",
                        anchor: new PIXI.Point(0.37, 0),
                        position: new PIXI.Point(0.966, 0.267),
                        rotation: Math.PI/10,
                        duration: 0.7
                    },
                    {
                        id: 18,
                        name: "cockpit2_deco_4",
                        anchor: new PIXI.Point(0.18, 0),
                        position: new PIXI.Point(0.07, 0.633),
                        rotation: Math.PI/9,
                        duration: 0.9
                    },
                ],
            3:
                [
                    {
                        id: 1,
                        isWeapon: true,
                        weaponId: 0,
                        name: "cockpit3_cannon_left",
                        shootFrame: "cockpit3_cannon_left_shoot"
                    },
                    {
                        id: 2,
                        isWeapon: true,
                        weaponId: 1,
                        name: "cockpit3_cannon_right",
                        shootFrame: "cockpit3_cannon_right_shoot"
                    },
                    {
                        id: 3,
                        name: "cockpit3_part_1",
                    },
                    {
                        id: 4,
                        name: "cockpit3_part_2",
                    },
                    {
                        id: 5,
                        name: "cockpit3_part_3",
                    },
                    {
                        id: 6,
                        name: "cockpit3_part_4",
                    },
                    {
                        id: 7,
                        name: "cockpit3_radar_",
                        animation: true,
                        frames: 6,
                        lastFrame: 5,
                        animSpeed: 0.2
                    },
                    {
                        id: 8,
                        name: "cockpit3_wave_",
                        animation: true,
                        frames: 6,
                        lastFrame: 5,
                        animSpeed: 0.2
                    },
                    {
                        id: 9,
                        name: "cockpit3_red_light_",
                        tweenType : "loading",
                        delay: 0.2,
                        parts: 4,
                        glow: true
                    },
                    {
                        id: 10,
                        name: "cockpit3_triangle_",
                        animation: true,
                        frames: 6,
                        lastFrame: 5,
                        animSpeed: 0.2
                    },
                    {
                        id: 11,
                        name: "cockpit3_light_1",
                        delay: 0,
                        duration: 1,
                        glow: true
                    },
                    {
                        id: 12,
                        name: "cockpit3_light_2",
                        delay: 0.3,
                        duration: 1.5,
                        glow: true
                    },
                    {
                        id: 13,
                        name: "cockpit3_light_3",
                        delay: 0.1,
                        duration: 0.5,
                        glow: true
                    },
                    {
                        id: 14,
                        name: "cockpit3_light_4",
                        delay: 0,
                        duration: 0.8,
                        glow: true
                    },
                    {
                        id: 15,
                        name: "cockpit3_light_5",
                        delay: 0.8,
                        duration: 0.8,
                        glow: true
                    },
                    {
                        id: 16,
                        name: "cockpit3_light_6",
                        delay: 0,
                        duration: 1,
                        glow: true
                    },
                    {
                        id: 17,
                        name: "cockpit3_light_7",
                        delay: 1.2,
                        duration: 0.9,
                        glow: true
                    },
                    {
                        id: 18,
                        name: "cockpit3_light_8",
                        delay: 0,
                        duration: 0.9,
                        glow: true
                    },
                    {
                        id: 19,
                        name: "cockpit3_light_9",
                        delay: 0.6,
                        duration: 0.9,
                        glow: true
                    },
                    {
                        id: 20,
                        name: "cockpit3_light_10",
                        delay: 0,
                        duration: 0.7,
                        glow: true
                    },
                    {
                        id: 21,
                        name: "cockpit3_light_11",
                        delay: 0.7,
                        duration: 0.7,
                        glow: true
                    },
                    {
                        id: 22,
                        name: "cockpit3_light_12",
                        delay: 0,
                        duration: 1.5,
                        glow: true
                    },
                    {
                        id: 23,
                        name: "cockpit3_light_13",
                        delay: 1,
                        duration: 1,
                        glow: true
                    },
                    {
                        id: 24,
                        name: "cockpit3_light_14",
                        delay: 0,
                        duration: 1,
                        glow: true
                    },
                    {
                        id: 25,
                        name: "cockpit3_dice",
                        anchor: new PIXI.Point(0.584, 0),
                        position: new PIXI.Point(0.097, 0.161),
                        rotation: Math.PI/12,
                        duration: 1
                    },
                ]
        };

        this.partsPortrait =
        {
            1:
                [
                    {
                        id: 1,
                        name: "cockpit_1_backBeam"
                    },
                    {
                        id: 3,
                        name: "cockpit_1_infoBeam"
                    },
                    {
                        id: 3,
                        name: "cockpit_1_soundBeam"
                    },
                    {
                        id: 4,
                        name: "cockpit_1_1_portrait"
                    },
                    {
                        id: 5,
                        name: "cockpit_1_2_portrait"
                    },
                    {
                        id: 6,
                        name: "cockpit_1_3_portrait"
                    },
                    {
                        id: 7,
                        name: "cockpit_1_4_portrait"
                    },
                    {
                        id: 8,
                        name: "cockpit_1_weapon"
                    },
                    {
                        id: 9,
                        name: "cockpit_1_weapon_animation_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 9,
                        animSpeed: 0.2,
                    },
                    {
                        id: 10,
                        name: "cockpit_1_beamCharge_",
                        animation: true,
                        frameLength: 2,
                        lastFrame: 8,
                        animSpeed: 9/12,
                        playOnShootOnly: true,
                        // replayDelay: .07,
                        startDelay: 0,
                        width: 1080,
                        height: 1920,
                    },
                    {
                        id: 11,
                        name: "cockpit_1_glow_1",
                        glow: true,
                        duration: 0.4,
                        delay: 0,
                        alpha: 0.5,
                    },
                    {
                        id: 12,
                        name: "cockpit_1_glow_2",
                        glow: true,
                        duration: 0.4,
                        delay: 0.1,
                    },
                    {
                        id: 13,
                        name: "cockpit_1_glow_3",
                        glow: true,
                        duration: 0.4,
                        delay: 0.2,
                    },
                    {
                        id: 14,
                        name: "cockpit_1_glow_4",
                        glow: true,
                        duration: 0.4,
                        delay: 0.3,
                        alpha: 0.5,
                    },
                    {
                        id: 15,
                        name: "cockpit_1_leftMonitor"
                    },
                    {
                        id: 16,
                        name: "cockpit_1_rightMonitor"
                    },
                ],
            2:
                [
                    {
                        id: 1,
                        isWeapon: true,
                        weaponId: 0,
                        // anchor: {x: 0.167, y: 0.95312},
                        anchor: {x: 0.18, y: 0.95},
                        name: "cockpit_2_weap_left",
                    },
                    {
                        id: 2,
                        isWeapon: true,
                        weaponId: 1,
                        // anchor: {x: 0.833, y: 0.95312},
                        anchor: {x: 0.82, y: 0.95},
                        name: "cockpit_2_weap_right",
                    },
                    {
                        id: 3,
                        name: "cockpit_2_leftWeap_electricity_",
                        animation: true,
                        frameLength: 2,
                        lastFrame: 9,
                        animSpeed: 0.2,
                        parentId: 1,
                    },
                    {
                        id: 4,
                        name: "cockpit_2_rightWeap_electricity_",
                        animation: true,
                        frameLength: 2,
                        lastFrame: 9,
                        animSpeed: 0.2,
                        parentId: 2,
                    },
                    {
                        id: 5,
                        name: "cockpit_2_weap_left_glow",
                        glow: true,
                        duration: 0.1,
                        delay: 0,
                        parentId: 1,
                        playOnShootOnly: true,
                        repeatDelay: 0.1
                    },
                    {
                        id: 6,
                        name: "cockpit_2_weap_right_glow",
                        glow: true,
                        duration: 0.1,
                        delay: 0,
                        parentId: 2,
                        playOnShootOnly: true,
                        repeatDelay: 0.1
                    },
                    {
                        id: 7,
                        name: "cockpit_2_weap_charge_left_",
                        animation: true,
                        frameLength: 2,
                        lastFrame: 6,
                        animSpeed: 6/12,
                        playOnShootOnly: true,
                        startDelay: 0,
                        parentId: 1,
                        width: 1080,
                        height: 1920,
                    },
                    {
                        id: 8,
                        name: "cockpit_2_weap_charge_right_",
                        animation: true,
                        frameLength: 2,
                        lastFrame: 6,
                        animSpeed: 6/12,
                        playOnShootOnly: true,
                        startDelay: 0,
                        parentId: 2,
                        width: 1080,
                        height: 1920,
                    },
                    {
                        id: 9,
                        name: "cockpit_2_1_portrait"
                    },
                    {
                        id: 10,
                        name: "cockpit_2_2_portrait"
                    },
                    {
                        id: 11,
                        name: "cockpit_2_3_portrait"
                    },
                    {
                        id: 12,
                        name: "cockpit_2_main_glow",
                        glow: true,
                        duration: 0.5,
                        delay: 0.5
                    }
                ],
            3:
                [
                    {
                        id: 1,
                        isWeapon: true,
                        weaponId: 0,
                        anchor: {x: 0.269, y: 0.95312},
                        name: "cockpit_3_weap_left",
                        // shootFrame: "cockpit_3_weap_left"
                    },
                    {
                        id: 2,
                        name: "cockpit_3_weap_left_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 9,
                        animSpeed: 0.2,
                        parentId: 1
                    },
                    {
                        id: 2,
                        name: "left_weapon_fire_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 2,
                        animSpeed: 3/12,
                        playOnShootOnly: true,
                        replayDelay: .07,
                        parentId: 1
                    },
                    {
                        id: 3,
                        name: "left_weapon_charge_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 3,
                        animSpeed: 4/12,
                        parentId: 1,
                        playOnShootOnly: true,
                        replayDelay: .07,
                        startDelay: 0//0.05
                    },
                    {
                        id: 4,
                        isWeapon: true,
                        weaponId: 1,
                        anchor: {x: 0.731, y: 0.95312},
                        name: "cockpit_3_weap_right",
                        // shootFrame: "cockpit_3_weap_right"
                    },
                    {
                        id: 5,
                        name: "cockpit_3_weap_right_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 9,
                        animSpeed: 0.2,
                        parentId: 2
                    },
                    {
                        id: 2,
                        name: "right_weapon_fire_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 2,
                        animSpeed: 3/12,
                        playOnShootOnly: true,
                        replayDelay: .07,
                        parentId: 2
                    },
                    {
                        id: 6,
                        name: "right_weapon_charge_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 3,
                        animSpeed: 4/12,
                        parentId: 2,
                        playOnShootOnly: true,
                        replayDelay: .07,
                        startDelay: 0//0.05
                    },
                    {
                        id: 7,
                        name: "cockpit_3_weap_mid"
                    },
                    {
                        id: 8,
                        name: "cockpit_3_weap_mid_shield"
                    },
                    {
                        id: 2,
                        name: "mid_weapon_fire_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 2,
                        animSpeed: 3/12,
                        playOnShootOnly: true,
                        replayDelay: .07,
                    },
                    {
                        id: 9,
                        name: "cockpit_3_weap_mid_shield_",
                        animation: true,
                        frameLength: 1,
                        lastFrame: 9,
                        animSpeed: 0.2,
                    },
                    {
                        id: 10,
                        name: "orb_charge_",
                        width: 1080,
                        height: 1920,
                        animation: true,
                        frameLength: 1,
                        lastFrame: 2,
                        animSpeed: 3/12,
                        playOnShootOnly: true,
                        replayDelay: .07,
                        startDelay: 0
                    },
                    {
                        id: 11,
                        name: "cockpit_3_1_portrait"
                    },
                    {
                        id: 12,
                        name: "cockpit_3_2_portrait"
                    },
                    {
                        id: 13,
                        name: "cockpit_3_wheel"
                    },
                    {
                        id: 14,
                        name: "cockpit_3_button_glow",
                        glow: true,
                        duration: 0.4,
                        delay: 0,
                    },
                    {
                        id: 15,
                        name: "cockpit_3_centreMonitor_glow",
                        glow: true,
                        duration: 0.5,
                        delay: 0,
                    },
                    {
                        id: 16,
                        name: "cockpit_3_leftMonitor_glow",
                        glow: true,
                        duration: 0.5,
                        delay: 0.2,
                    },
                    {
                        id: 17,
                        name: "cockpit_3_rightBotMonitor_glow",
                        glow: true,
                        duration: 0.5,
                        delay: 0.3,
                    },
                    {
                        id: 18,
                        name: "cockpit_3_rightTopMonitor_glow",
                        glow: true,
                        duration: 0.5,
                        delay: 0,
                    },
                    {
                        id: 19,
                        name: "cockpit_3_light_glow",
                        glow: true,
                        duration: 0.5,
                        delay: 0,
                    },
                ]
        };
    }

}

export default (new C_CockpitParts);